/**
 * @generated SignedSource<<b1fbf9ac45813f4d79c2c1ec6f8bee24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PricingGuidancePriceRange = "HIGHER_RANGE" | "LOWER_RANGE" | "MEDIAN" | "NEAR_MEDIAN_HIGH" | "NEAR_MEDIAN_LOW" | "OUT_OF_RANGE_HIGH" | "OUT_OF_RANGE_LOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbPricingGuidance_item$data = {
  readonly pricingGuidance: {
    readonly priceRange: PricingGuidancePriceRange | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPricingGuidanceSoldLink_item" | "useShowSiderailSoldPricingGuidance_item">;
  readonly " $fragmentType": "PdpRespSidebarBlurbPricingGuidance_item";
};
export type PdpRespSidebarBlurbPricingGuidance_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbPricingGuidance_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbPricingGuidance_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbPricingGuidance_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "concreteType": "PricingGuidance",
      "kind": "LinkedField",
      "name": "pricingGuidance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceRange",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowSiderailSoldPricingGuidance_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPricingGuidanceSoldLink_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "02a75ffce11695e24b8dcf51019c910d";

export default node;
